import { ApiCallError } from 'app/http/ApiCallError';

export const getPaymentMethodsLoadErrorMessage = (error: unknown): string | null => {
  if (error instanceof ApiCallError && error.status === 401) {
    return null;
  }
  if (error instanceof ApiCallError && error.status === 403) {
    return 'You do not have access to payment methods';
  }
  return 'Unable to load payment methods. Please try again.';
};
